import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/sass/affiliate.scss";
import { END_POINT } from "../../constants/defaultValues";

const AffiliateSignup = ({ history }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    bank_name: "",
    bank_number: "",
    bank_holder: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${END_POINT}/api/affiliate/signup`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        alert("Đăng ký thành công! Vui lòng chờ xét duyệt.");
        history.push("/login");
      } else {
        setError(data.responseText || "Đăng ký thất bại");
      }
    } catch (err) {
      console.error(err);
      setError("Lỗi kết nối server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aff-auth-page">
      <div className="aff-auth-wrapper wide">
        <div className="aff-auth-card">
          <div className="aff-auth-logo">
            <img
              src="/assets/img/logo-horizontal.svg"
              alt="VMASS Affiliate"
              style={{ height: "40px" }}
            />
          </div>

          <div className="aff-auth-header">
            <h1 className="aff-auth-title">Trở thành Đối tác</h1>
            <p className="aff-auth-subtitle">
              Kiếm thu nhập không giới hạn từ mỗi khách hàng bạn giới thiệu
            </p>
          </div>

          {error && (
            <div className="aff-auth-error">
              <span>⚠️</span> {error}
            </div>
          )}

          <form onSubmit={handleSignup} className="aff-auth-form">
            <div className="aff-auth-row">
              <div className="aff-auth-field">
                <label className="aff-auth-label">👤 Họ và tên</label>
                <input
                  name="name"
                  type="text"
                  className="aff-auth-input"
                  onChange={handleChange}
                  required
                  placeholder="Nguyễn Văn A"
                />
              </div>
              <div className="aff-auth-field">
                <label className="aff-auth-label">📱 Số điện thoại</label>
                <input
                  name="phone"
                  type="tel"
                  className="aff-auth-input"
                  onChange={handleChange}
                  required
                  placeholder="0912 345 678"
                />
              </div>
            </div>

            <div className="aff-auth-field">
              <label className="aff-auth-label">📧 Email</label>
              <input
                name="email"
                type="email"
                className="aff-auth-input"
                onChange={handleChange}
                required
                placeholder="email@example.com"
              />
            </div>

            <div className="aff-auth-field">
              <label className="aff-auth-label">🔒 Mật khẩu</label>
              <input
                name="password"
                type="password"
                className="aff-auth-input"
                onChange={handleChange}
                required
                placeholder="Tối thiểu 6 ký tự"
              />
            </div>

            <div className="aff-auth-divider">
              <span>THÔNG TIN NHẬN TIỀN</span>
            </div>

            <div className="aff-auth-bank">
              <p className="aff-auth-bank-title">
                🏦 Tài khoản ngân hàng <small>(Có thể bổ sung sau)</small>
              </p>

              <div className="aff-auth-row">
                <div className="aff-auth-field">
                  <label className="aff-auth-label">Ngân hàng</label>
                  <input
                    name="bank_name"
                    type="text"
                    className="aff-auth-input"
                    onChange={handleChange}
                    placeholder="VD: Vietcombank"
                  />
                </div>
                <div className="aff-auth-field">
                  <label className="aff-auth-label">Số tài khoản</label>
                  <input
                    name="bank_number"
                    type="text"
                    className="aff-auth-input"
                    onChange={handleChange}
                    placeholder="1029384756"
                  />
                </div>
              </div>

              <div className="aff-auth-field">
                <label className="aff-auth-label">Chủ tài khoản</label>
                <input
                  name="bank_holder"
                  type="text"
                  className="aff-auth-input"
                  onChange={handleChange}
                  placeholder="NGUYEN VAN A"
                />
              </div>
            </div>

            <button type="submit" disabled={loading} className="aff-auth-btn">
              {loading ? (
                <span className="aff-auth-spinner"></span>
              ) : (
                "Tạo tài khoản →"
              )}
            </button>
          </form>

          <div className="aff-auth-footer">
            <span>Đã có tài khoản? </span>
            <Link to="/login" className="aff-auth-link">
              Đăng nhập
            </Link>
          </div>
        </div>

        <Link to="/" className="aff-auth-back">
          ← Quay lại trang chủ
        </Link>
      </div>
    </div>
  );
};

export default AffiliateSignup;
